<template>
  <b-container>
    <b-row>
      <b-col>
        <Heading type="h1" :title="trans('global.settings')" />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form id="settings-select-pl-form">
          <b-form-group
            id="form-pl-select"
            label="Velg PL"
          >
            <b-form-select
              :v-model="prospect.brand"
              :value="prospect.brand || null"
              variant="primary"
              class="d-inline-block"
              :options="brandOptions"
              :disabled="disabled"
              @change="submit"
            ></b-form-select>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form id="settings-show-designer-form">
          <b-form-group
            id="form-designer-select"
            label="Skal designeren vises?"
          >
            <b-form-select
              :v-model="prospect.enableDesigner"
              :value="prospect.enableDesigner || 0"
              variant="primary"
              class="d-inline-block"
              :options="designerOptions"
              :disabled="designerDisabled"
              @change="submitDesigner"
            ></b-form-select>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form id="settings-show-designer-form">
          <b-form-group
            id="form-price-select"
            label="Skal designeren vise priser?"
          >
            <b-form-select
              :v-model="prospect.enablePrices"
              :value="prospect.enablePrices || 0"
              variant="primary"
              class="d-inline-block"
              :options="pricesOptions"
              :disabled="pricesDisabled"
              @change="submitPrices"
            ></b-form-select>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form id="settings-show-login-btn">
          <b-form-group
            id="form-login-toggle"
            label="Skal loginknappen vises?"
          >
            <b-form-select
              :v-model="prospect.disableLoginBtn"
              :value="prospect.disableLoginBtn || false"
              variant="primary"
              class="d-inline-block"
              :options="loginBtnOptions"
              :disabled="loginBtnDisabled"
              @change="submitLoginBtn"
            ></b-form-select>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import Heading from '../../../../Core/Heading'

  const fb = require('../../../../../firebaseConfig')

  export default {
    name: 'ProjectSalesProspectSettings',
    components: {
      Heading
    },
    props: {
      prospect: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      disabled: false,
      brandOptions: [
        { value: null, text: 'Velg en PL for dette prospektet' },
        { value: 'crown', text: 'Crown' },
        { value: 'diabas', text: 'Diabas' },
        { value: 'dnbeiendom', text: 'DNB Eiendom' },
        { value: 'hellvikhus', text: 'Hellvikhus' },
        { value: 'keo', text: 'Keo' },
        { value: 'trysilhus', text: 'Trysilhus' },
        { value: 'glitrebolig', text: 'Glitre Bolig' },
        { value: 'swedoor', text: 'Swedoor' },
        { value: 'hobbelstad', text: 'Hobbelstad og Rønning' },
        { value: 'sotelifjell', text: 'Søtelifjell' },
        { value: 'blockwatne', text: 'Block Watne' },
        { value: 'build17', text: 'Build 17' },
        { value: 'trebo', text: 'Trebo Entreprenør' },
        { value: 'vikenstrom', text: 'Viken Strøm' }
      ],
      designerDisabled: false,
      designerOptions: [
        { value: 0, text: 'Nei' },
        { value: 1, text: 'Ja' }
      ],
      pricesDisabled: false,
      pricesOptions: [
        { value: 0, text: 'Nei' },
        { value: 1, text: 'Ja' }
      ],
      loginBtnDisabled: false,
      loginBtnOptions: [
        { value: false, text: 'Ja' },
        { value: true, text: 'Nei' }
      ]
    }),
    methods: {
      submit (value) {
        console.log('SUBMITTING:', this.prospect.brand)

        this.disabled = true

        if (this.prospect._id !== undefined) {
          fb.prospectsCollection.doc(this.prospect._id).update({
            brand: value
          }).then(() => {
            this.$bvToast.toast('Prospektet ble oppdatert!', {
              title: this.trans('global.success'),
              variant: 'success',
              solid: true
            })
          }).catch((err) => {
            this.$bvToast.toast('Prospektet ble ikke oppdatert...', {
              title: this.trans('global.error'),
              variant: 'danger',
              solid: true
            })
            console.log(err)
          }).finally(() => {
            this.disabled = false
          })
        } else {
          console.log('Missing prospect ID')
        }
      },
      submitDesigner (value) {
        console.log('SUBMITTING:', this.prospect.brand)

        this.designerDisabled = true

        if (this.prospect._id !== undefined) {
          fb.prospectsCollection.doc(this.prospect._id).update({
            enableDesigner: value
          }).then(() => {
            this.$bvToast.toast('Designeren vil nå vises, eller ikke, avhengig av hva du valgte', {
              title: this.trans('global.success'),
              variant: 'success',
              solid: true
            })
          }).catch((err) => {
            this.$bvToast.toast('Prospektet ble ikke oppdatert...', {
              title: this.trans('global.error'),
              variant: 'danger',
              solid: true
            })
            console.log(err)
          }).finally(() => {
            this.designerDisabled = false
          })
        } else {
          console.log('Missing prospect ID')
        }
      },
      submitPrices (value) {
        console.log('SUBMITTING:', this.prospect.brand)

        this.pricesDisabled = true

        if (this.prospect._id !== undefined) {
          fb.prospectsCollection.doc(this.prospect._id).update({
            enablePrices: value
          }).then(() => {
            this.$bvToast.toast('Valget ble oppdatert!', {
              title: this.trans('global.success'),
              variant: 'success',
              solid: true
            })
          }).catch((err) => {
            this.$bvToast.toast('Valget ble ikke oppdatert...', {
              title: this.trans('global.error'),
              variant: 'danger',
              solid: true
            })
            console.log(err)
          }).finally(() => {
            this.pricesDisabled = false
          })
        } else {
          console.log('Missing prospect ID')
        }
      },
      submitLoginBtn (value) {
        console.log('SUBMITTING:', this.prospect.disableLoginBtn)

        this.loginBtnDisabled = true

        if (this.prospect._id !== undefined) {
          fb.prospectsCollection.doc(this.prospect._id).update({
            disableLoginBtn: value
          }).then(() => {
            this.$bvToast.toast('Valget ble oppdatert!', {
              title: this.trans('global.success'),
              variant: 'success',
              solid: true
            })
          }).catch((err) => {
            this.$bvToast.toast('Valget ble ikke oppdatert...', {
              title: this.trans('global.error'),
              variant: 'danger',
              solid: true
            })
            console.log(err)
          }).finally(() => {
            this.loginBtnDisabled = false
          })
        } else {
          console.log('Missing prospect ID')
        }
      }
    }
  }
</script>
